export default "/kiban/_next/static/images/bottom_yellow-41be67fefc1078eb094390befb7a5194.png";